import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const TechnologyPartnersDetailsForNRO = lazy(() =>
  import("@scenes/TechnologyPartners/TechnologyPartnersDetails").then((module) => ({
    default: module.TechnologyPartnersDetails,
  }))
);

export const technologyPartnersDetailsNRO: NavigationRoutingObject = {
  section: "partner-integrations",
  Component: TechnologyPartnersDetailsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("technology-partners-sidebar-pill-menu-option", "Technology Partners"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "partner-integrations-description-nav",
      "View our partners and connect Braze to the technologies your team uses"
    ),
  icon: "nav-system-technology-partners",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/technology_partners/technology-partners/:appGroupId",
};
